import { render, staticRenderFns } from "./viewTestimonial.vue?vue&type=template&id=030c484e&"
import script from "./viewTestimonial.vue?vue&type=script&lang=js&"
export * from "./viewTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports